/* eslint-disable @next/next/no-img-element */

import { useGSAP } from '@gsap/react';
import cls from 'classnames';
import gsap from 'gsap';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React, { useRef } from 'react';

import { ButtonProps } from '@/components/Button';
import LeadButton from '@/components/LeadButton';
import Title, { TitleProps } from '@/components/Title';
import TrustpilotMicroStar from '@/components/TrustpilotBar/MicroStar';

interface IBanner {
  title: string;
  subTitle: string;
  age?: string;
  btnName: string;
  useTranslationName: string;
  subject: 'math' | 'english';
  className?: string;
  ga: string;
  ga4: string;
  alt: string;
}

const Banner = ({
  useTranslationName,
  title,
  subTitle,
  btnName,
  subject,
  className,
  ga,
  ga4,
  alt,
}: IBanner) => {
  const { t } = useTranslation([useTranslationName]);

  const container = useRef<HTMLDivElement>(null);

  //   // h1文字和视频 同时渐显 持续1s
  //   // 剩余元素 渐显  持续1s （ fadeClass opacity-0 ）
  //   // 评价自动滚动
  //   // 视频滚动
  useGSAP(
    () => {
      gsap
        .timeline()
        .to('.h1Title', { opacity: 1, duration: 1 }, 0)
        .fromTo(
          '.video1',
          { scale: 0, transformOrigin: '0% 0%' },
          {
            scale: 1,
            transformOrigin: '0% 0%',
            duration: 0.5,
            ease: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
          },
          0,
        )
        .to('.fadeClass', { opacity: 1, duration: 0.8 }, 0.4);
    },
    { scope: container },
  );

  const TitleThemeClass: Record<string, TitleProps['theme']> = {
    math: 'math',
    english: 'english',
  };

  const ButtonThemeClass: Record<string, ButtonProps['theme']> = {
    math: 'math',
    english: 'english',
  };

  const bannerBgImg = {
    math: '/images/englishMathBanner/math-banner-bg.png',
    english: '/images/englishMathBanner/english-banner-bg.png',
  };

  // const ageClass = {
  //   math: 'bg-[linear-gradient(181deg,#0092FF_37.14%,#00FFE0_94.75%)]',
  //   english: 'bg-[linear-gradient(161deg,#8642F8_42.48%,#F442F8_72.82%)]',
  // };

  // const ageClassName = `class="${ageClass[subject]} bg-clip-text text-transparent  whitespace-nowrap"`;

  // const ageAvatar = {
  //   math: '/images/englishMathBanner/math-banner-avatar.png',
  //   english: '/images/englishMathBanner/english-banner-avatar.png',
  // };

  const classHtml = () => {
    return (
      <div className="fadeClass opacity-0">
        <div className="mt-6 px-5 lg:mt-[50px] lg:px-0 xl:mt-[70px]">
          <div className=" text-center lg:text-left">
            <LeadButton
              theme={ButtonThemeClass[subject]}
              subject={subject}
              size="xl"
              className=""
              traceName={ga}
              traceGa4Name={ga4}>
              <strong style={{ fontWeight: 'unset' }}>{t(btnName)}</strong>
            </LeadButton>
          </div>
          <div className="mt-[18px] flex justify-center lg:justify-start xl:mt-7">
            <TrustpilotMicroStar className="w-full max-w-[280px]" />
          </div>
        </div>
      </div>
    );
  };

  return (
    <section
      ref={container}
      className={cls('container relative z-10', className)}>
      {/* 内容 */}
      <div className=" relative mt-[124px] flex flex-col  justify-between  lg:mt-[196px] lg:flex-row  lg:pl-[70px] lg:pr-9 xl:mt-[177px]  xl:pl-[120px] xl:pr-20 ">
        <div className="h1Title relative flex-1 shrink-0 opacity-0 lg:w-[510px] xl:w-[691px] xl:pt-11">
          <Title
            className=" relative z-20 lg:text-left [&]:lg:text-3xl [&]:lg:leading-normal [&]:xl:text-[48px] [&]:xl:leading-normal"
            innerHTML
            theme={TitleThemeClass[subject]}
            htmlLabel="h1">
            {`${t(title)}
          `}
            {/* <span class="hidden lg:inline-block relative z-[-1] -top-1.5 lg:top-0">
            <span class=" lg:absolute lg:flex lg:h-[66px] xl:h-[88px] xl:top-[-75px] xl:-left-8 lg:-left-6 lg:-top-[58px]">
              <span class=" lg:h-[66px]  lg:w-[66px] lg:block  xl:h-[88px] xl:w-[88px]">
                <Image
                  src=${ageAvatar[subject]}
                  alt="WuKong"
                  class="inline-block"
                  width={88}
                  height={88}
                />
              </span>
              <span class=" relative z-10 self-end">
                <span class=" inline-block rounded-[1px_10px_10px_10px] border border-white bg-[linear-gradient(135deg,#ffffff,rgba(255,255,255,0.5))] py-0.5 pl-3 pr-2.5 text-base font-bold leading-normal shadow-[0px_4px_9px_rgba(0,0,0,0.08)] xl:-ml-3 lg:-ml-2  lg:mb-2 lg:text-sm lg:leading-normal">
                  <span ${ageClassName}>
                  ${t(age)}
                  </span>
                </span>
              </span>
            </span>
          </span> */}
          </Title>
          <p
            className=" mt-3 text-center text-base  text-wk-words-2 lg:mt-5 lg:text-left lg:text-lg xl:text-xl [&_b]:font-semibold"
            dangerouslySetInnerHTML={{ __html: t(subTitle) }}
          />
          <div className="hidden lg:block">{classHtml()}</div>
        </div>
        {/* PC 固定宽度 移动端铺满 */}
        <div className="video1 relative mx-auto mt-6 flex  justify-end lg:mt-0 lg:h-[334px] lg:w-[356px]  xl:h-[484px] xl:w-[515px]">
          <Image
            src={bannerBgImg[subject]}
            sizes="100vw"
            className="h-auto w-full"
            width={515}
            height={484}
            alt={t(alt)}
            loading="eager"
            priority
          />
        </div>
      </div>

      <div className="lg:hidden">{classHtml()}</div>
    </section>
  );
};

export default Banner;
